import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useMediaQuery from 'react-use-media-query-hook';

import Dropzone from '../../../components/Dropzone';
import {
  ARCHITECTURAL_MINIMAL_TEMPLATE_NAME,
  COMMENT_PROPOSITION,
  COLORS,
  TITLE_MODAL_STYLE_ARCH,
  BUTTON_MODAL_STYLE_ARCH,
  BUTTON_LIGHT_MODAL_STYLE_ARCH,
  IMAGE_ASPECT_RATIO_ONE,
  IMAGE_ASPECT_RATIO_VP_ARCH,
} from '../../../utils/const';
import SectionHeader from '../../../components/SectionHeader';
import { renderSegmentList } from '../../../utils/helpers/renderSegmentList';
import { renderText } from '../../../utils/helpers/renderText';
import PortfolioCommentIcon from '../../../components/PortfolioCommentIcon';
import { getColorDependsOnBackgroundAndPalette } from '../../../utils/helpers/portfolioArchTemplate/getColorDependsOnBackgroundAndPalette';
import { getImageAspectRatio } from '../../../utils/helpers/getImageAspectRatio';

const { black } = COLORS;

const ValuePropositionArch = ({
  data: { description },
  locales: {
    portfolio,
    valueProposition: {
      intro: { card },
    },
  },
  locales,
  backgroundSection,
  backgroundImage,
  backgroundModal,
  colorPaletteNumber,
  disabled = false,
}) => {
  const {
    valueProposition: { product, reason, image, imageCoords },
    uniqueSellingPoint: { collection },
  } = useSelector((state) => state);

  const { uploadingImage } = useSelector((state) => state.valueProposition);

  const isDesktop = useMediaQuery('(max-width: 1280px)');

  const {
    valueProposition: {
      updateAttributeImage,
      updateValuePropositionImageCoords,
    },
    portfolio: { updateSectionField },
  } = useDispatch();

  const onImageDrop = ([file], openCropperHandler) => {
    updateAttributeImage({
      name: 'image',
      value: URL.createObjectURL(file),
      blob: file,
      success: () => {
        openCropperHandler();
      },
    });
  };

  const onImageCropperSave = (croppedAreaPixels, innerCropData, zoom) => {
    updateValuePropositionImageCoords({
      croppedAreaPixels,
      innerCropData,
      zoom,
      coords: imageCoords,
    });
  };

  const textColor = getColorDependsOnBackgroundAndPalette(
    colorPaletteNumber,
    backgroundSection,
  );

  return (
    <div
      className="value-propositions-architectural relative"
      style={{ backgroundColor: backgroundSection }}
    >
      <PortfolioCommentIcon title={COMMENT_PROPOSITION} />
      <div className="left">
        <SectionHeader
          templateName={ARCHITECTURAL_MINIMAL_TEMPLATE_NAME}
          title={portfolio.valueProposition.sectionTitle}
          description={description}
          onChange={(e) =>
            updateSectionField({
              sectionName: 'valueProposition',
              field: 'description',
              name: 'vpText',
              value: e.target.value,
            })
          }
          portfolio={portfolio}
          colorPaletteNumber={colorPaletteNumber}
          style={{ color: textColor }}
          descriptionColor={textColor}
          disabled={disabled}
        />
        {renderSegmentList(card.solutionTitle, textColor)}
        {renderText(product, textColor)}
        {renderSegmentList(card.featuresTitle, textColor)}
        {renderText(reason, textColor)}
        {renderSegmentList(card.pointsTitle, textColor)}
        {renderText(
          collection.map((point, index) => (
            <div className="margin-bottom-10" key={point.id || index}>
              {point.description}
            </div>
          )),
          textColor,
        )}
      </div>
      <div className="right">
        <div className="drop">
          <Dropzone
            className="drop-image"
            onDrop={onImageDrop}
            onCropperSave={onImageCropperSave}
            locales={locales}
            image={image}
            coords={imageCoords}
            uploading={uploadingImage}
            aspectRatio={getImageAspectRatio(
              isDesktop,
              IMAGE_ASPECT_RATIO_ONE,
              IMAGE_ASPECT_RATIO_VP_ARCH,
            )}
            background={{ backgroundColor: backgroundImage }}
            disabled={disabled}
            titleStyle={TITLE_MODAL_STYLE_ARCH}
            buttonStyle={BUTTON_MODAL_STYLE_ARCH}
            lightButtonStyle={BUTTON_LIGHT_MODAL_STYLE_ARCH}
            sliderColor={black}
            backgroundModal={backgroundModal}
            isTemplates
            cropper
          />
        </div>
      </div>
    </div>
  );
};

export default ValuePropositionArch;
